import React from 'react'
import { Button } from 'reactstrap';
import { FormRol } from './FormRol';
import { ModalViewView } from './ModalViewView';
import { Dialog } from 'primereact/dialog';

export const ModalRol = (props) => {

    const {
        modalRoles,
        closeDialog,
        modalTitle,
        methodRoles,
        loading,
        handleInputChange,
        handleSelectValues,
        validationsRole,
        listViews,
        listRolesData,
        name,
        ids_views,
        saveCreateRol,
        saveUpdateRole
    } = props;


    const footer = (
        <>
            <hr />

            {
                methodRoles === "view"
                ?
                    <Button
                        color="danger"
                        size="sm"
                        onClick={closeDialog}
                    >
                        Cerrar
                    </Button>

                :
                <>
                    <Button
                        color="danger"
                        size="sm"
                        onClick={closeDialog}
                    >
                        Cancelar
                    </Button>

                    <Button
                        color="primary"
                        size="sm"
                        disabled={loading}
                        onClick={
                            methodRoles === "create"
                                ? saveCreateRol
                                : saveUpdateRole
                        }
                        className={
                            loading
                                ? "progress-bar-animated progress-bar-striped"
                                : ""
                        }
                    >
                        {
                            loading
                            ?
                            <>
                                <i className="fa fa-spinner fa-spin me-2" />

                                {
                                    methodRoles === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                            :
                                methodRoles === "create"
                                    ? "Guardar"
                                    : "Actualizar"
                        }
                    </Button>
                </>
            }

        </>
    );


    return (

        <Dialog
            header={modalTitle}
            visible={modalRoles}
            onHide={closeDialog}
            closable
            modal
            blockScroll
            className={
                methodRoles === "view"
                    ? "medium-dialog"
                    : "large-dialog"
            }
            footer={footer}
        >

            {
                methodRoles === "create"
                    ?
                    <FormRol
                        button='Guardar'
                        {...{
                            loading,
                            name,
                            ids_views,
                            handleInputChange,
                            handleSelectValues,
                            validationsRole,
                            methodAction: saveCreateRol,
                            listViews
                        }}
                    />

                    :
                    methodRoles === "update"
                    ?
                    <FormRol
                        button='Actualizar'
                        {...{
                            loading,
                            name,
                            ids_views,
                            handleInputChange,
                            handleSelectValues,
                            validationsRole,
                            methodAction: saveUpdateRole,
                            listViews
                        }}
                    />

                    :
                    methodRoles === "view"
                    ?
                    <ModalViewView
                        {...{ listRolesData }}
                    />

                    :
                    null
            }

        </Dialog>
    )
}